import * as Yup from 'yup'

const EMAIL = {
  email: Yup.string().email('Email Inválido.').required('Obligatorio'),
}

const USERNAME = {
  username: Yup.string()
    .strict(true)
    .trim('No inicie o termine con espacios en blanco.')
    .min(3, 'Nombre demasiado corto, digite más de 3 caracteres.')
    .max(50, 'Nombre demasiado largo, máx 50 caracteres.')
    .required('Obligatorio'),
}

const LASTNAME = {
  lastname: Yup.string()
    .strict(true)
    .trim('No inicie o termine con espacios en blanco.')
    .min(3, 'Apellido demasiado corto, digite más de 3 caracteres.')
    .max(50, 'Apellido demasiado largo, max. 50 caracteres.')
    .required('Obligatorio'),
}

const PASSWORD_LOGIN = {
  password_login: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .required('Obligatorio'),
}

const PASSWORD = {
  password: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .min(8, 'Contraseña demasiado corta, digite 8 caracteres como mínimo.')
    .max(16, 'Contraseña demasiado larga, digite 16 caracteres como máximo.')
    .matches(/^(?=\w*\d)\S/, 'Al menos un dígito.')
    .matches(/^(?=\w*[A-Z])\S/, 'Al menos una mayúscula.')
    .matches(/^(?=\w*[a-z])\S/, 'Al menos una minúscula.')
    .matches(/^(?=\w*[a-zA-Z0-9])\S{8,16}$/, 'Evite espacios en blanco.'),
}

const PASSWORD_CONFIRMATION = {
  password_confirmation: Yup.string().when('password', val => {
    if (val?.length > 0)
      return Yup.string()
        .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
        .required('Obligatorio')

    return Yup.string().notRequired()
  }),
}

const PASSWORD_ALT = {
  password_alt: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .min(8, 'Contraseña demasiado corta, digite 8 caracteres como mínimo.')
    .max(16, 'Contraseña demasiado larga, digite 16 caracteres como máximo.')
    .matches(/^(?=\w*\d)\S/, 'Al menos un dígito.')
    .matches(/^(?=\w*[A-Z])\S/, 'Al menos una mayúscula.')
    .matches(/^(?=\w*[a-z])\S/, 'Al menos una minúscula.')
    .matches(/^(?=\w*[a-zA-Z0-9])\S{8,16}$/, 'Evite espacios en blanco.')
    .required('Obligatorio'),
}

const PASSWORD_CONFIRMATION_ALT = {
  password_confirmation_alt: Yup.string()
    .oneOf([Yup.ref('password_alt')], 'Las contraseñas no coinciden')
    .required('Obligatorio'),
}

const CODE = {
  code_: Yup.string()
    .max(20, 'Demasiado largo, máx. 20 caracteres.')
    .min(3, 'Demasiado corto, mín. 3 caracteres.')
    .required('Obligatorio'),
}

const SPECIE = {
  specie_: Yup.string()
    .max(35, 'Demasiado largo, 35 caracteres como máximo.')
    .required('Obligatorio'),
}

const MEASURING_GROUP = {
  measuring_group: Yup.number().required(),
}

const FAMILY = {
  family_: Yup.string()
    .max(30, 'Demasiado largo, 30 caracteres como máximo.')
    .required('Obligatorio'),
}

const SITE = {
  site_: Yup.string()
    .max(60, 'Demasiado largo, 60 caracteres como máximo.')
    .min(5, 'Demasiado corto, mín. 5 caracteres.')
    .required('Obligatorio'),
}

const SECTION = {
  section_: Yup.string().when('section_', val => {
    if (val?.length > 0) {
      return Yup.string()
        .max(200, 'Demasiado largo, 200 caracteres como máximo.')
        .required('Obligatorio')
    }
    return Yup.string().notRequired()
  }),
}

const PARISH = {
  parish_: Yup.string()
    .max(100, 'Demasiado largo, 100 caracteres como máximo.')
    .required('Obligatorio'),
}

const TYPE_SECTION = {
  typeSite_: Yup.string()
    .max(45, 'Demasiado largo, 45 caracteres como máximo.')
    .required('Obligatorio'),
}

const RECORDED = {
  recorded_: Yup.string()
    .max(75, 'Demasiado largo, 75 caracteres como máximo.')
    .required('Obligatorio'),
}

const ALIVE = {
  alive_: Yup.string().required('Obligatorio'),
}

const TREEVERIFIED = {
  treeVerified_: Yup.string().required('Obligatorio'),
}

const COMMIT = {
  commit_: Yup.string().required('Obligatorio'),
}

const DATE = {
  date_: Yup.date()
    .min('01 Jan 2021', 'Fecha mínima mayor al Jan 2021')
    .required('Obligatorio')
    .typeError('Fecha no válida'),
}

const ALTITUDE = {
  altitud: Yup.number()
    .max(5000, 'Altitud máxima 5000 msnm')
    .positive('Debe ser mayor a 0 msnm')
    .typeError('No es un número válido'),
}

const LONG = {
  longX: Yup.number().required('Obligatorio'),
}

const LAT = {
  latY: Yup.number().required('Obligatorio'),
}

const CAP = {
  cap: Yup.number()
    .min(0.5, 'CAP mínima 0.5 cm')
    .max(3000, 'CAP máxima 3000 cm')
    .typeError('No es un número válido'),
}

const DAP = {
  dap: Yup.number()
    .min(1, 'DAP mínima 1 cm')
    .max(500, 'DAP máxima 500 cm')
    .typeError('No es un número válido'),
}

const HT = {
  ht: Yup.number()
    .positive('HT mayor que 0 m')
    .max(100, 'HT máxima 100 m')
    .typeError('No es un número válido'),
}

const HC = {
  hc: Yup.number()
    .positive('HC mayor que 0 m')
    .max(100, 'HC máxima 100 m')
    .typeError('No es un número válido'),
}

const CROWN_NS = {
  copaNS: Yup.number()
    .positive('Copa(NS) mayor que 0 m')
    .max(500, 'Copa(NS) máxima 500 m')
    .typeError('No es un número válido'),
}

const CROWN_EW = {
  copaEW: Yup.number()
    .positive('Copa(EW) mayor que 0 m')
    .max(500, 'Copa(EW) máxima 500 m')
    .typeError('No es un número válido'),
}

const FOLIAGE = {
  follaje: Yup.number()
    .integer('Ingrese números enteros')
    .min(0, 'Porcentaje mín. 0%')
    .max(100, 'Porcentaje máx. 100%')
    .typeError('No es un número válido'),
}

const MATURITY = options => ({
  madurez: Yup.string().when('madurez', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const BLOOMING = options => ({
  floracion: Yup.string().when('floracion', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const FRUCTIFICATION = options => ({
  fructificacion: Yup.string().when('fructificacion', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const STRAIGHTNESS = options => ({
  fusteRectitud: Yup.string().when('fusteRectitud', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const SPACING = options => ({
  espaciamiento: Yup.string().when('espaciamiento', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const ROOTQUALITY = options => ({
  calidadRaiz: Yup.string().when('calidadRaiz', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const FUSTEQUALITY = options => ({
  calidadFuste: Yup.string().when('calidadFuste', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const BARKQUALITY = options => ({
  calidadCorteza: Yup.string().when('calidadCorteza', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const BRANCHESQUALITY = options => ({
  calidadRamas: Yup.string().when('calidadRamas', val => {
    if (val) return Yup.string().oneOf(options, 'Ccampo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const LEAVESQUALITY = options => ({
  calidadHojas: Yup.string().when('calidadHojas', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const TOPQUALITY = options => ({
  calidadCima: Yup.string().when('calidadCima', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const CROWNQUALITY = options => ({
  calidadCopa: Yup.string().when('calidadCopa', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const RISKFALLING = options => ({
  rsgoCaida: Yup.string().when('rsgoCaida', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const CONSTRUCTIONRISK = options => ({
  rsgoAfeccionConstr: Yup.string().when('rsgoAfeccionConstr', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const INTERFCIRCULATION = options => ({
  rsgoInterfCirculacion: Yup.string().when('rsgoInterfCirculacion', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const INFRASTRUCTURERISK = options => ({
  rsgoInfraestructura: Yup.string().when('rsgoInfraestructura', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const ELECTRICALNETWORKSRISK = options => ({
  rsgoRedesElectricas: Yup.string().when('rsgoRedesElectricas', val => {
    if (val) return Yup.string().oneOf(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().notRequired()
  }),
})

const OTHERSRISK = {
  riesgoOtros: Yup.string().when('riesgoOtros', val => {
    if (val?.length > 0)
      return Yup.string()
        .min(4, 'Mínimo 4 caracteres')
        .max(75, 'Máximo 75 caracteres')
        .required('Obligatorio')

    return Yup.string().notRequired()
  }),
}

export const schema = {
  EMAIL,
  USERNAME,
  LASTNAME,
  PASSWORD,
  PASSWORD_ALT,
  PASSWORD_LOGIN,
  PASSWORD_CONFIRMATION,
  PASSWORD_CONFIRMATION_ALT,
  CODE,
  SPECIE,
  FAMILY,
  // PSEUDONYM,
  MEASURING_GROUP,
  SITE,
  SECTION,
  PARISH,
  TYPE_SECTION,
  RECORDED,
  ALIVE,
  TREEVERIFIED,
  COMMIT,
  DATE,
  //Features
  ALTITUDE,
  LONG,
  LAT,
  CAP,
  DAP,
  HT,
  HC,
  CROWN_NS,
  CROWN_EW,
  FOLIAGE,
  MATURITY,
  BLOOMING,
  FRUCTIFICATION,
  STRAIGHTNESS,
  SPACING,
  // Inconveniences with options control input
  ROOTQUALITY,
  FUSTEQUALITY,
  BARKQUALITY,
  BRANCHESQUALITY,
  LEAVESQUALITY,
  TOPQUALITY,
  CROWNQUALITY,
  RISKFALLING,
  CONSTRUCTIONRISK,
  INTERFCIRCULATION,
  INFRASTRUCTURERISK,
  ELECTRICALNETWORKSRISK,
  OTHERSRISK,
}
